module.exports = __webpack_public_path__ + "static/media/rating_banner_image.11d80deb.png";